import { checkResponse } from "../utils/checkResponse";
import { DomainAPI, Channel, getHeader } from "../utils/setting";

const packages = {
  state: {
    packageName: "basic",
    package: {},
    list: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changePackage(state, payload) {
      state.packageName = payload.packageName;
      state.package = payload.package;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    updatePackage(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/packages/updatePackage";
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload)
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // if (result.code === 1) {
          //   _this.setState({ list: result.data });
          // }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getListPackage(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/packages/getListPackage";
      return fetch(url, {
        method: "GET",
        headers: getHeader(true, rootState.user.token),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({ list: result.data });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default packages;
